import classes from './ModalPackSelect.module.css';

import magic from '../../../assets/svg/magic.svg';
import deleteIcon from '../../../assets/svg/delete-01.svg';
import attentionIcon from '../../../assets/svg/attention-01.svg';

import Icon from '../../../helpers/components/Icon';
import React from 'react';
import { getListBarcodes } from '../../../services/list.services';
import { deletePackType, getPackTypes } from '../../../services/pucks.services';
import BarcodesMultiList from '../../Widgets/BarcodesMultiList';
import { observer } from 'mobx-react-lite';
import Modal from '../../../ui/Modal';
import { useForm, FormProvider, Controller } from 'react-hook-form';
import FormTextField from '../../../ui/formItems/FormTextField';
import FormSelect from '../../../ui/formItems/FormSelect';
import useAlert from '../../../hooks/useAlert';

const ModalPackSelect = observer(
  ({
    openModal,
    mode,
    action,
    onClose,
    storageId = 0,
  }) => {
    const { showAlert } = useAlert();
    const [packs, setPacks] = React.useState([]);
    const [selectedKey, setSelectedKey] = React.useState();
    const [name, setName] = React.useState('');

    const form = useForm({
      defaultValues: {
        barcodes: [],
        name: '',
        pack: null,
      },
    });

    const {
      handleSubmit,
      setValue,
      watch,
    } = form;

    const formBarcodes = watch('barcodes');

  React.useEffect(() => {
    loadFreePack();
  }, []);

  React.useEffect(() => {
    loadFreePack();
  }, [mode.puckAddModal]);

    React.useEffect(() => {
      if (name.length === 0) {
        let pack = packs.find((i) => i.id === selectedKey);
        if (pack) {
          setName(pack.name);
        }
      }
    }, [selectedKey]);

    const loadFreePack = async () => {
      let res = await getPackTypes();
      if (res.length === 0) {
        alarmNotFreePackAlert();
        return;
      }
      setPacks(res);
    };

    const submitForm = async (data) => {
      action({
        storageId: storageId,
        barcodes: data.barcodes,
        type: data.pack,
        name: data.name,
      });
      successAddedPackAlert();
    };

    const deleteType = async (id) => {
      const res = await deletePackType(id);
      if (res.success) {
        setSelectedKey(null);
        setName('');
        await loadFreePack();
        alarmInfoDeletPackAlert();
      } else {
        alarmPackNotUniqueAlert();
      }
    };

    const successAddedPackAlert = () => showAlert(`Штатив добавлен успешно!`, 'success');

    const alarmNotFreePackAlert = () => {
      showAlert(`Нет свободных штативов!`, 'error');
    };

    const alarmInfoDeletPackAlert = () => {
      showAlert(`Тип штатива удален!`, 'info');
    };

    const alarmPackNotUniqueAlert = () => {
      showAlert(`Тип штатива уже используется!`, 'error');
    };

    const handleDeleteBarcode = (index) => {
      const newBarcodes = [...formBarcodes];
      newBarcodes.splice(index, 1);
      setValue('barcodes', newBarcodes);
    };

    if (!openModal) return null;

    return (
      <Modal title={`Добавить штатив`} onSubmit={handleSubmit(submitForm)} onClose={onClose}>
        <FormProvider {...form}>
          <FormTextField name="name" label="Наименование" required />
          <div className={classes.wrapperSelect}>
            <span className={classes.labelPack}>Тип штатива</span>
            <FormSelect
              required
              name="pack"
              options={packs}
              valueKey="id"
              className={classes.select}
              titleKey="name"
              renderOption={({ option }) => (
                <div
                  className={classes.optionWrapper}>
                  <span className={classes.optionName}>{option.name}</span>
                  <Icon
                    width="15px"
                    height="15px"
                    color={'var(--color-brand)'}
                    src={deleteIcon}
                    onClick={(e) => {
                      e.stopPropagation();
                      deleteType(option.id);
                    }}
                  />
                </div>
              )}
            />
            <div className={classes.addNewPuckButton} onClick={() => mode.setPuckAddModal(true)}>
              <Icon color={'#1d6030'} width={'25px'} height={'25px'} src={magic} />
            </div>
          </div>
          <div className={classes.wrapperBarcode}>
            <span className={classes.labelBarcode}>Штрихкоды</span>
            <Controller
              name="barcodes"
              control={form.control}
              rules={{
                validate: {
                  required: (value) => {
                    const isValid = value?.length > 0;
                    return isValid || 'Поле обязательно для заполнения';
                  },
                  validItems: (value) => {
                    if (!value || value.length === 0) return true;
                    const hasEmptyValues = value.some(
                      (item) => !item?.value || item.value.trim() === '',
                    );
                    return !hasEmptyValues || 'Все штрихкоды должны содержать значение';
                  },
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <div>
                  <BarcodesMultiList
                    list={field.value || []}
                    getItemsList={getListBarcodes}
                    setList={(val) => field.onChange(val)}
                    onDeleteItem={handleDeleteBarcode}
                  />
                  {error?.message && (
                    <div className={classes.dataErrorBlock}>
                      <img src={attentionIcon} alt={'attention'} />
                      <div className={classes.dataError}>{error?.message}</div>
                    </div>
                  )}
                </div>
              )}
            />
          </div>
        </FormProvider>
      </Modal>
    );
  },
);

export default ModalPackSelect;
